/*
 * @Author: Dom
 * @Date: 2022-05-26 23:31:59
 * @LastEditTime: 2022-07-20 11:37:41
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\authent\component\enterprise\service.ts
 */
import request from '@/utils/request';
import {EnterpriseParamsApi} from './data'


export async function saveUserEnterprise(params:EnterpriseParamsApi): Promise<any> {
    return request({
        url: '/seller/v1/user/saveUserEnterprise',
        method: 'POST',
        data: params,
    });
}
